
export default class SubscribeForm {

	static getHolderSelectors = () => ['.subscribe-form-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		holderElement.querySelectorAll('.mc-field-group input').forEach(i => {
			const label = holderElement.querySelector(`[for="${i.id}"]`);
			i.addEventListener('focus', () => label.classList.add('active'));
			i.addEventListener('blur', () => {
				!i.value && label.classList.remove('active')
			});
		});

		const submit = holderElement.querySelector('#mc_embed_signup input[type="submit"]');
		if (submit) {
			submit.classList.add('btn', 'btn-outline-secondary');
			submit.classList.remove('button');
		}
	}

}
